"use client";

import dynamic from "next/dynamic";

const GlobalErrorHandler = dynamic(() => import("./GlobalErrorHandler"), {
  ssr: false,
  loading: () => null,
});

export default function ClientErrorHandlerWrapper() {
  return <GlobalErrorHandler />;
}
